import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskDelayUI = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskDelayUI;
